import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const postNotification = async ({
  type = "mail",
  title,
  message,
  receiver,
}) => {
  let _receivers = ``;
  if (receiver.length > 1) {
    receiver.forEach((r, index) => {
      if (index < receiver?.length - 1) {
        _receivers += `${r}@bot.go.tz,`;
      } else {
        _receivers += `${r}@bot.go.tz`;
      }
    });
  } else {
    _receivers = `${receiver[0]}@bot.go.tz`;
  }

  const reqOpts = {
    headers: {
      Accept: "*/*",
    },
    validateStatus: (status) => {
      return status < 500;
    },
  };

  try {
    let payload = {
      sender: "frsp-info@bot.go.tz",
      password: `1qaz!QAZ`,
      replyTo: "frsp@bot.go.tz",
      receiver: _receivers,
      subject: `${title}`,
      body: `<p>Dear  ${receiver?.length === 1 ? receiver[0] : "All"},</p>
                <p>${message}</p>
                <p>Thank you.</p>`,
    };
    // const response = await notificationServiceApi.post(
    //   `/${type?.toLowerCase()}`,
    //   payload,
    //   reqOpts
    // );

    // return response;
    return true;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSystemParameters = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("common/params", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getRoles = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("roles", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
